import { useTranslation } from 'react-i18next';

interface ComingSoonStateProps {
  feature?: string;
}

export function ComingSoonState({ feature }: ComingSoonStateProps) {
  const { t } = useTranslation();
  const featureName = feature ?? t('gateway.shared.comingSoon.defaultFeature');

  return (
    <div
      role="status"
      aria-live="polite"
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 'var(--spacing-8) var(--spacing-6)',
        gap: 'var(--spacing-4)',
        textAlign: 'center',
        background: 'var(--color-surface-muted)',
        border: '1px solid var(--color-surface-border)',
        borderRadius: 'var(--radius-lg)',
        margin: 'var(--spacing-6)',
      }}
    >
      <div
        aria-hidden="true"
        style={{
          fontSize: '48px',
          lineHeight: 1,
        }}
      >
        🚧
      </div>
      <h2
        style={{
          margin: 0,
          fontSize: 'var(--font-size-lg)',
          color: 'var(--color-text-primary)',
        }}
      >
        {t('gateway.shared.comingSoon.title', { feature: featureName })}
      </h2>
      <p
        style={{
          margin: 0,
          fontSize: 'var(--font-size-sm)',
          color: 'var(--color-text-secondary)',
          maxWidth: '480px',
          lineHeight: 1.5,
        }}
      >
        {t('gateway.shared.comingSoon.description')}
      </p>
      <p
        style={{
          margin: 0,
          fontSize: 'var(--font-size-xs)',
          color: 'var(--color-text-muted)',
        }}
      >
        {t('gateway.shared.comingSoon.note')}
      </p>
    </div>
  );
}
